import { useMemo } from 'react';
import useSWRImmutable from 'swr/immutable';

import type { GameCategory } from '@/api/games';
import { fetcherSS } from '@/modules/api';

export const useCollections = () => {
  const {
    data = [],
    error,
    isLoading,
  } = useSWRImmutable<GameCategory[]>('/games/collections', fetcherSS);

  const collections = useMemo(
    () => new Map(data.map((category) => [category.id, category])),
    [data]
  );

  return {
    isLoading,
    isError: !!error,
    collections,
  };
};
